import React, { useState } from 'react';
import useStyle from './customSwitch.style';

export interface CustomSwitchProps {
  choiceOne: string;
  choiceTwo: string;
  onClick: (value: boolean) => void;
  defaultValue?: boolean;
}

export const CustomSwitch = ({
  choiceOne,
  choiceTwo,
  onClick,
  defaultValue = true
}: CustomSwitchProps) => {
  const classes = useStyle();
  const [selected, setSelected] = useState(defaultValue);

  const onChange = (value: boolean) => {
    setSelected(value);
    onClick(value);
  };

  return (
    <div className={classes.container}>
      <div
        onClick={() => onChange(true)}
        className={`${classes.children} ${selected && classes.selected}`}
      >
        {choiceOne}
      </div>
      <div
        onClick={() => onChange(false)}
        className={`${classes.children} ${!selected && classes.selected}`}
      >
        {choiceTwo}
      </div>
    </div>
  );
};
